module.exports = __webpack_public_path__ + "img/b_drive.d010039f.png";